module.exports = __webpack_public_path__ + "img/after_lawn_treatment.614b645f.png";